<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="/lop-hoc">Lớp học của tôi</router-link></li>
                    <li><router-link to="">{{ this.$route.query.className }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container-hts">
            <div class="name-leson margin-top-20">
                <h3>
                    <strong>{{ dataLessonPlaning.name }}</strong>
                </h3>
            </div>
            <b-tabs pills class="pre-class-school-list__filter__tabs b-class-tabs">
                <b-tab @click="changeTab(tabInfo)" title="Thông tin kế hoạch giảng dạy" :active="tabActive == tabInfo">
                    <TabInfoLessonPlaning :dataLessonPlaning="dataLessonPlaning"
                        v-if="tabActive == tabInfo && dataLessonPlaning.name" />
                </b-tab>
                <b-tab @click="changeTab(tabContent)" title="Nội dung kế hoạch giảng dạy"
                    :active="tabActive == tabContent">
                    <TabContentLessonPlaning :dataLessonPlaning="dataLessonPlaning"
                        v-if="tabActive == tabContent && dataLessonPlaning.name" />
                </b-tab>

            </b-tabs>
        </div>
    </section>
</template>
<script>
import { getDetail } from './../../_api/LessonClassSchoolServices'
import TabInfoLessonPlaning from './TabInfoLessonPlaning'
import TabContentLessonPlaning from './TabContentLessonPlaning'
export default {
    components: {
        TabInfoLessonPlaning,
        TabContentLessonPlaning
    },
    data() {
        return {
            tabActive: 2,
            tabInfo: 1,
            tabContent: 2,
            dataLessonPlaning: {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                isPublic: false,
                type: 4
            },
        }
    },
    mounted() {
        this.dataLessonPlaning.id = this.$route.query.id
        this.getDetailLessonClassSchool()
    },
    methods: {
        changeTab(tab) {
            this.tabActive = tab
        },
        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.dataLessonPlaning.id).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataLessonPlaning = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        isPublic: res.data.isPublic,
                        type: res.data.type,
                    }
                }
            })
        },
    }
}
</script>
<style lang="scss">
.wrap-name-item {
    cursor: pointer;
    border-bottom: 1px solid #dee2e6;
}

.margin-top-20 {
    margin-top: 20px;
}

.name-leson {
    color: #2032b5;
}
</style>